/* eslint-disable indent */
import isEmpty from 'lodash/isEmpty';
import compact from 'lodash/compact';
import { useSelector } from 'react-redux';
import {
  configuratorChoicesForCustomSelections,
  configuratorOptions,
} from '../../selectors/configurator';
import { selectSelectedSkuData } from '../../selectors/skuDataSelectors';
import { selectSelectedCarpetChoice } from '../../selectors/pricing';
import { getHdmsStoreIdSelector } from '../../selectors/thdStoreInfo';
import { roomMeasureCountSelector, totalRoomMeasureAreaSelector } from '../../selectors/roomMeasure';
import { findTaggedValue } from '../../utils/tags';

const collectionNameFromProductLabel = (skuData) => {
  const { productLabel } = skuData;
  if (productLabel) {
    const firstHyphen = productLabel.indexOf('-');
    const collectionName = productLabel.substring(0, firstHyphen);
    return collectionName.trim();
  }
  return '';
};

const useConfiguratorExtraSelections = () => {
  const extraSelections = useSelector(configuratorChoicesForCustomSelections);
  const configOptions = useSelector(configuratorOptions);
  const selectedSkuData = useSelector(selectSelectedSkuData);
  const selectedChoice = useSelector(selectSelectedCarpetChoice);
  const storeNumber = useSelector(getHdmsStoreIdSelector);
  const roomsCount = useSelector(roomMeasureCountSelector);
  const totalRoomsArea = useSelector(totalRoomMeasureAreaSelector);

  const setChoiceValueByShortLabel = (label, values) => {
    switch (label) {
      case 'Store Id': return storeNumber;
      case 'Color': return values.skuColor;
      case 'Room': return JSON.stringify(values.roomInfo);
      default: return null;
    }
  };

  return compact(extraSelections.map((choice) => {
    const option = configOptions[choice.optionId];
    const hasSuperSkuData = !isEmpty(selectedSkuData);
    let roomInfo = '';

    if (option === null) {
      throw new Error(`Error building selections: can't find option with ID:${choice.optionId}`);
    }

    if (!isEmpty(selectedChoice)) {
      const { tags } = selectedChoice;
      const collection = hasSuperSkuData
        ? collectionNameFromProductLabel(selectedSkuData)
        : findTaggedValue(tags, 'collection');
      const brand = hasSuperSkuData ? selectedSkuData.brandName : findTaggedValue(tags, 'brand');
      const sku = hasSuperSkuData ? selectedSkuData.sku : findTaggedValue(tags, 'sku');
      const sampleomsid = hasSuperSkuData ? selectedSkuData.sampleId : findTaggedValue(tags, 'sampleomsid');
      roomInfo = {
        collection: !collection ? brand : `${brand} - ${collection}`,
        totalArea: totalRoomsArea,
        sku,
        sampleomsid,
        roomsCount,
      };
      const choiceValues = {
        skuColor: hasSuperSkuData ? '' : findTaggedValue(selectedChoice.tags, 'colorfamily'),
        roomInfo
      };
      return {
        optionId: choice.optionId,
        choiceId: choice.id,
        choiceValue: setChoiceValueByShortLabel(choice.shortLabel, choiceValues) || choice.value,
        optionType: option.optionType,
        optionTags: option.tags,
      };
    }
    return undefined;
  }));
};

export default useConfiguratorExtraSelections;
